<template>
  <div>
    <div
      v-for="(analysisMethod, idx) in analysisMethods"
      :key="idx"
    >
      <section
        v-for="key in Object.keys(analysisMethod)"
        :key="key"
      >
        <h1 class="is-inline-block has-text-weight-semibold is-padded-small">
          {{ key | underscoresToSpaces | capitalizeFirstLetter }}
        </h1>
        <p class="is-inline-block is-padded-small">{{ analysisMethod[key] }}</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    analysisMethods: {
      type: Array,
      required: true
    }
  }
}
</script>
